import { useCallback } from "react";
import { VelavuStreamUpdateOperation, VelavuStreamUpdateTarget } from "velavu-js-api";
import { useVelavuStream } from "../stream/StreamContext";
/**
 * A hook that listens for new alerts
 * @param callback The callback to call with each new alert
 */
export function useNewAlertListener(callback) {
    useVelavuStream(VelavuStreamUpdateTarget.Event, useCallback((event) => {
        if (event.operation === VelavuStreamUpdateOperation.Created
            && event.body.category === "ALERT") {
            callback(event.body);
        }
    }, [callback]));
}
//# sourceMappingURL=alertHook.js.map